var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup107752(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10775",
    "data-name": "Group 10775",
    transform: "translate(20943 16637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7446",
    "data-name": "Rectangle 7446",
    width: 24,
    height: 24,
    transform: "translate(-20943 -16637)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10774",
    "data-name": "Group 10774",
    transform: "translate(399.098 70.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31912",
    "data-name": "Path 31912",
    d: "M-21193.4-16586.2h-7.668a3.2,3.2,0,0,0-2.225,1.24,3.2,3.2,0,0,0-.613,2.473,2.943,2.943,0,0,0,2.838,2.445l1.262,0v2.426a5.437,5.437,0,0,1-6.377-3.518,5.75,5.75,0,0,1,1.986-6.547,4.562,4.562,0,0,1,2.791-.947h8.006Z",
    transform: "translate(-125.494 -108.599)",
    fill: "#fe4675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31913",
    "data-name": "Path 31913",
    d: "M-21094.5-16698.1s-.82-4.516,3.076-4.721c-.035.055,0-2.424,0-2.424a5.487,5.487,0,0,0-5.689,4.795,7.785,7.785,0,0,0,.146,2.35Z",
    transform: "translate(-227.473 -0.002)",
    fill: "#fe4675"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7443",
    "data-name": "Rectangle 7443",
    width: 2.101,
    height: 7.353,
    transform: "translate(-21324.541 -16693.66)",
    fill: "#fe4675"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7444",
    "data-name": "Rectangle 7444",
    width: 10.504,
    height: 2.101,
    transform: "translate(-21341.348 -16698.912)",
    fill: "#fe4675"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7445",
    "data-name": "Rectangle 7445",
    width: 2.101,
    height: 10.504,
    transform: "translate(-21337.146 -16696.811)",
    fill: "#fe4675"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup107752);
export default __webpack_public_path__ + "static/media/Group 10775 (2).1cad7c36fd3b23fcf67a68a6c951a79d.svg";
export { ForwardRef as ReactComponent };